export default {"src":"/_next/static/media/literature.0afe1d71.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};